import React from 'react';
import { connect } from 'react-redux';
import TooltipElement from '../components/tooltipElement';
import TooltipButtonGroup from '../components/tooltipButtonGroup';
import TrialLicenseTable from '../components/trialLicenseTable';
import OverlayLoader from '../components/overlayLoader';
import * as trialLicensesActions from '../store/trialLicensesSlice';
import { trialLicensesSelectors } from '../store/trialLicensesSlice';
import './common.css';
import setTitleToFilters from '../common/filtersTitles';

class TrialLicensesContainer extends React.Component {
  componentDidMount() {
    setTitleToFilters();
    this.props.fetchTrialLicenses();
  }

  render() {
    return (
      <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
        <div>
          <h1>Trial licenses</h1>
          {this.renderButtons()}
          {this.renderContent()}
        </div>
      </OverlayLoader>
    );
  }

  renderButtons = () => (
    <TooltipButtonGroup>
      <TooltipElement type="button" text="Refresh" icon="refresh" onClick={this.props.fetchTrialLicenses}/>
    </TooltipButtonGroup>
  );

  renderContent = () => {
    if (this.props.trialLicensesFetchingError)
      return this.renderError();
    return (
      <TrialLicenseTable trialLicenses={this.props.trialLicenses}/>
    );
  };

  renderError = () => (
    <p className="text-danger">Error: {this.props.trialLicensesFetchingError.toString()}</p>
  );

  isLoading = () => this.props.isTrialLicensesFetching;

  getLoaderMessage = () => {
    if (this.props.isTrialLicensesFetching) {
      return "Trial licenses loading...";
    }
  };
}

const mapStateToProps = (state) => ({
  isTrialLicensesFetching: trialLicensesSelectors.isFetching(state),
  trialLicenses: trialLicensesSelectors.selectAll(state),
  trialLicensesFetchingError: trialLicensesSelectors.fetchingError(state)
});

const actionCreators = {
  fetchTrialLicenses: trialLicensesActions.fetchAll,
};

export default connect(mapStateToProps, actionCreators)(TrialLicensesContainer);



// WEBPACK FOOTER //
// ./src/containers/trialLicensesContainer.js